
import FAQ2 from "../components/FAQ2";
import Footer from "../components/Footer";
import Header from "../components/Header";

function WeddingTransportation() {
  return (
    <>
    <section 
      className="relative w-full min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] bg-cover bg-center"
      style={{
        backgroundImage: "url('blog12.png')",
      }}
    >
      <Header/>

      {/* Hero Content */}
      <div className="relative z-20 flex items-center justify-center min-h-[40vh] sm:min-h-[50vh] lg:min-h-[60vh] px-4">
        <div className="max-w-5xl text-center text-white">
          <h1 className="font-bold leading-snug text-white">
            Wedding Transportation
          </h1>
          <div className="mt-6 flex justify-center gap-2 text-sm font-medium">
            <a href="/" className="hover:text-logo-green">Home</a>
            <span>-</span>
            <span className="text-logo-green">Wedding Transportation</span>
          </div>
        </div>
      </div>
    </section>

       <section className="bg-white py-10 sm:py-10 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Image Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <img 
          src="fleet6.png" 
          alt="NYC Wedding Limousine Service" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Text Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          NYC Wedding Limousine Service
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Our NYC Wedding Limousine Service provides elegant, reliable transportation designed to make your special day seamless and memorable. With a fleet of luxury vehicles and professional chauffeurs, we ensure timely arrivals, smooth rides, and exceptional comfort for the couple and wedding party.
        </p>
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          From the first pickup to the final drop-off, every detail is handled with care, allowing you to focus on celebrating your wedding in style and peace of mind.
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Text Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Luxury and Stylish Wedding Transportation Services in New York City
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Make your wedding day truly unforgettable with our luxury and stylish wedding transportation services in New York City. We specialize in premium wedding limousines, luxury sedans, SUVs, and stretch limos designed to provide comfort, elegance, and reliability.
        </p>
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          Our professional chauffeurs ensure timely arrivals and seamless coordination between your ceremony, photo locations, and reception venues. Whether you're planning an intimate celebration or a grand NYC wedding, our stylish transportation services add sophistication and peace of mind, making your special day smooth, memorable, and stress-free.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>

      {/* Image Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <img 
          src="blog12.png" 
          alt="Luxury Wedding Transportation Services NYC" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Image Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <img 
          src="fleet6.png" 
          alt="How to Book Luxury Wedding Transportation NYC" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Text Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          How Can You Book Luxury Wedding Transportation in New York City?
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Booking luxury wedding transportation in New York City is easier than ever with professional limousine and chauffeur services dedicated to making your big day seamless. Start by researching reputable providers that offer a fleet of luxury vehicles, including limousines, SUVs, and classic sedans.
        </p>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Look for services with strong reviews, verified safety records, and packages tailored to wedding needs. Early planning ensures availability, especially during peak wedding seasons.
        </p>
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          Once you've selected your preferred service, reach out to discuss your wedding details. Provide information such as the date, locations for pick-up and drop-off, the number of guests, and any special requests. A professional provider will guide you through available vehicles, pricing, and customized packages to fit your schedule and style. Clear communication ensures that every aspect of your wedding transportation is coordinated perfectly.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Text Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Looking for a Wedding Bus for Large Groups in Your Area?
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          If you're planning an out-of-town wedding or need to transport a large group of guests from EWR, LGA, or JFK airports to their hotel or from the hotel to your wedding venue explore NY City Limo's bus rental options.
        </p>
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          No matter the size of your wedding party, you can choose from luxury vans, stretch limousines, limo buses, or a dedicated wedding party bus to meet all your transportation needs. Browse our full selection of well-maintained, high-end vehicles on the Fleet page to find the perfect ride for your special day.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>

      {/* Image Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <img 
          src="blog12.png" 
          alt="Wedding Bus for Large Groups NYC" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Image Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <img 
          src="fleet6.png" 
          alt="Luxury Wedding Limousine Service with Low Rates NYC" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Text Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Luxury Wedding Limousine Service with Low Rates in New York City
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          NY City Limo offers exclusive wedding limo packages in convenient 3-hour increments, complete with complimentary champagne for the bride and groom. Choose from a fleet of meticulously maintained, polished limousines, each designed to provide a flawless blend of elegance and comfort.
        </p>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          The luxurious interiors are spotless and crafted to impress, ensuring a memorable experience for everyone on board.
        </p>
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          Turn your wedding day vision into reality with the help of our expert luxury transportation specialists. From the first pick-up to the final drop-off, we provide seamless, sophisticated NYC wedding limo service tailored to your needs. With attention to detail, professional chauffeurs, and premium vehicles, we ensure every moment of your special day is celebrated in style, comfort, and elegance. Make your wedding day extraordinary by reserving a NY City Limo wedding limousine where luxury, reliability, and impeccable service meet to create unforgettable memories.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Text Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          The Best Wedding Chauffeurs Coverage Area
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          If you're searching for the ultimate wedding limousine in NYC, NY City Limo is the top choice near you. We provide luxurious, reliable transportation for your special day, serving all of New York City and the surrounding areas.
        </p>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          No matter your preference for stretch limousines, elegant sedans, spacious SUVs, or party buses NY City Limo offers the perfect vehicle to match your style and wedding plans. Our professional chauffeurs cover all five boroughs, including Manhattan, Brooklyn, Queens, the Bronx, and Staten Island.
        </p>
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          From chic downtown venues to intimate backyard celebrations in Queens, we ensure seamless, stylish transportation. Hosting your wedding in Westchester, Long Island, or New Jersey? We're there too, bringing luxury and convenience wherever you need it.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>

      {/* Image Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <img 
          src="blog12.png" 
          alt="Best Wedding Chauffeurs Coverage Area NYC" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>
    </div>
  </div>
</section>

<section className="bg-white py-8 sm:py-8 px-4 sm:px-6 lg:px-10">
  <div className="max-w-[1200px] mx-auto">
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 items-center">
      {/* Image Side - First on mobile, left on desktop */}
      <div className="order-1 lg:order-1">
        <img 
          src="fleet6.png" 
          alt="Get Me a Wedding Limo Nearby" 
          className="w-full h-64 sm:h-80 lg:h-96 object-cover rounded-lg shadow-lg"
        />
      </div>

      {/* Text Side - Second on mobile, right on desktop */}
      <div className="order-2 lg:order-2">
        <h2 className="font-bold text-black mb-3 sm:mb-4 leading-tight">
          Get Me a Wedding Limo Nearby!
        </h2>
        <p className="mb-3 sm:mb-4 leading-relaxed text-gray-900">
          Hire a personal driver online or call +17182004140 or +17182004140, and New York's most glamorous limousine service will be at your service. Let an established local livery service plan and carry out your transportation as smoothly as possible.
        </p>
        <p className="mb-4 sm:mb-6 leading-relaxed text-gray-900">
          Focus on your partner and everyone you love instead of stressing yourself out because of unprofessional luxury transportation.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4">
          <a 
            href="/booknow" 
            className="bg-black border-2 border-white text-white px-6 sm:px-8 py-3 font-semibold hover:bg-gray-900 transition-colors text-center"
          >
            BOOK NOW
          </a>
          <a 
            href="tel:+17182004140" 
            className="bg-white text-black border-2 border-black px-6 sm:px-8 py-3 font-semibold hover:bg-gray-100 transition-colors text-center"
          >
            CALL NOW
          </a>
        </div>
      </div>
    </div>
  </div>
</section>
    
    <FAQ2/>

    <Footer/>
    </>
  );
}

export default WeddingTransportation;
